// Single source of truth for "Didampingi" pricing (docs/nontech/CONTRACT.md §Fase 3, PRD F3.2).
// Client-safe (no server imports) so both `guided.server.ts` and client components (e.g.
// `src/components/simple/doors.tsx`) read the same numbers instead of duplicating them in copy.
export const REVIEW_KINDS = ['review15', 'polish', 'pair60'] as const
export type ReviewKind = (typeof REVIEW_KINDS)[number]

/** Fixed prices, IDR only (Pakasir/QRIS). */
export const REVIEW_PACKAGES: Record<ReviewKind, { priceIdr: number; minutes: number }> = {
  review15: { priceIdr: 150_000, minutes: 15 },
  polish: { priceIdr: 350_000, minutes: 60 },
  pair60: { priceIdr: 500_000, minutes: 60 },
}

/** Human answers within one working day of payment. */
export const SLA_HOURS = 24

/**
 * "Rp 150 rb" shorthand used by the doors screen (`simple_door_guided_p1..p3`) — kept as its own
 * formatter (not `fmtCurrency`) so the interpolated {price} renders exactly the text that used
 * to be hardcoded in messages/parts/simple.*.json, in both locales.
 */
export const formatReviewPriceShort = (idr: number) => `Rp ${idr / 1000} rb`
